export default __webpack_public_path__ + "media/EMERALD PACKAGE.d6d7d776494f05c926cb493c63a1e82d.mp4";